import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { all } from '@awesome.me/kit-bc84d927de/icons'

library.add(...all)

// convert i tags to SVG
dom.watch({
    autoReplaceSvgRoot: document,
    observeMutationsRoot: document.body
})
